import React, { useEffect } from 'react';
import { Parallax } from 'react-parallax';

// Hooks
import { useInView } from 'react-intersection-observer';
import { useAppState } from '../../state/appState';

import { ArrowLinkButton } from '../ui';

const FeatureBanner = ({ banner, headline, link }) => {
  const { setReverseHeader } = useAppState();

  const [ref, inView] = useInView({
    /* Optional options */
    threshold: 0,
  });

  useEffect(() => {
    setReverseHeader(inView);
    return () => {
      setReverseHeader(false);
    };
  }, [inView, setReverseHeader]);

  return (
    <Parallax
      className="h-screen relative w-full flex items-center justify-center text-sand bg-black"
      bgImage={banner && banner.asset && banner.asset.url}
      strength={200}
      bgImageStyle={{ height: '100vh', objectFit: 'cover' }}
    >
      <div className="relative z-10 text-center" ref={ref}>
        <h1 className="font-displayDrop text-3xl md:text-6xl text-center leading-tight max-w-3xl px-4">
          {headline}
        </h1>
        <ArrowLinkButton {...link} className="justify-center mt-16" />
      </div>
    </Parallax>
  );
};

export default FeatureBanner;
